module.exports = __webpack_public_path__ + "media/images/dividend/ill-envelope-043ff14ca2571937fce483efcd54e838.svg";